import React, { useContext } from "react"
import { Modal } from "react-bootstrap";
import {
  Button,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import language from "../../../nls/language.json";
import Context from "../../../context/Context";
import { DatePicker, LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import '../MessageSector.css';

export default function AddMensagemModal({
  showModalAdd,
  setShowModalAdd,
  handleAddMessage,
  selectedAddMessage,
  postMessageSector,
  allSectors
}) {
  const {
    selectedCountry,
  } = useContext(Context);

  return (
    <Modal show={showModalAdd} onHide={() => setShowModalAdd(false)}>
      <Modal.Header closeButton>
        <Modal.Title>
          {language[selectedCountry.name].Cadastro.mensagemSetor.modal.adicionar.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="d-flex flex-column">
          <div className="d-flex flex-row">
            <TextField
              className="mt-2 mb-3 w-100"
              label="Mensagem"
              name="mensagem_Texto"
              required
              fullWidth
              id="outlined-basic"
              placeholder="Mensagem"
              onChange={({ target }) => handleAddMessage({
                name: "mensagem_Texto",
                value: target.value.toUpperCase()
              })}
            />
          </div>
          <div className="d-flex flex-row">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Data Início"
                format="DD/MM/YYYY"
                value={dayjs(selectedAddMessage.mensagem_DataInicio)}
                onChange={(e) => handleAddMessage({ name: "mensagem_DataInicio", value: new Date(e.$d) })}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Hora Início"
                ampm={false}
                value={dayjs(selectedAddMessage.mensagem_DataInicio)}
                onChange={(e) => {
                  const date = new Date(selectedAddMessage.mensagem_DataInicio)
                  date.setHours((e.$H))
                  date.setMinutes(e.$m)
                  handleAddMessage({ name: "mensagem_DataInicio", value: date })
                }}
              />
            </LocalizationProvider>
          </div>
          <div className="d-flex flex-row mt-2">
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Data Fim"
                format="DD/MM/YYYY"
                value={dayjs(selectedAddMessage.mensagem_DataFim)}
                onChange={(e) => handleAddMessage({ name: "mensagem_DataFim", value: new Date(e.$d) })}
              />
            </LocalizationProvider>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                label="Hora Fim"
                ampm={false}
                value={dayjs(selectedAddMessage.mensagem_DataFim)}
                onChange={(e) => {
                  const date = new Date(selectedAddMessage.mensagem_DataFim)
                  date.setHours((e.$H))
                  date.setMinutes(e.$m)
                  handleAddMessage({ name: "mensagem_DataFim", value: date })
                }}
              />
            </LocalizationProvider>
          </div>
          <FormControlLabel
            className="w-50"
            control={
              <Checkbox
                checked={selectedAddMessage.isagA_Mensagem_Setores.length === allSectors.length}
                onChange={(e) => handleAddMessage(
                  { name: "msgSetor_Setor", value: allSectors },
                  e.target.checked ? "ALL" : "ALL_REMOVE")}
              />}
            label={"SELECIONAR TODOS"}
          />
          <div className="d-flex flex-row mt-2 flex-wrap justify-content-between">
            {allSectors.length && allSectors.map((item, index) => (
              <FormControlLabel
                className="w-25"
                key={`checkbox-add-message${index}`}
                control={
                  <Checkbox
                    checked={selectedAddMessage.isagA_Mensagem_Setores.some(message => message?.msgSetor_Setor === item.stR_description)}
                    onChange={(e) => handleAddMessage(
                      { name: "msgSetor_Setor", value: item.stR_description },
                      e.target.checked ? "ADD" : "REMOVE")
                    }
                  />}
                label={item.stR_description}
              />
            ))}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="text"
          sx={{ marginRight: 2 }}
          onClick={() => setShowModalAdd(false)}
        >
          {language[selectedCountry.name].Cadastro.mensagemSetor.modal.adicionar.btnCancelar}
        </Button>
        <Button
          variant="contained"
          onClick={() => postMessageSector(selectedAddMessage)}
          disabled={!selectedAddMessage.mensagem_Texto}
        >
          {language[selectedCountry.name].Cadastro.mensagemSetor.modal.adicionar.btnSalvar}
        </Button>
      </Modal.Footer>
    </Modal >
  )
}

